import { RootState, useSelector } from '../redux/store';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { DeviceType } from '../@types/model/user';

interface DeviceTypePickerProps {
  deviceTypePreset: string;
  changeHandler: (deviceTypePreset: string) => void;
  deviceTypeAvailable: string[];
}

const DeviceTypePicker = (props: DeviceTypePickerProps) => {
  const { t } = useTranslation();
  const { loaded, deviceTypes } = useSelector((state: RootState) => state.user);
  const [deviceTypesFiltered, setDeviceTypesFiltered] = useState<DeviceType[]>([]);

  useEffect(() => {
    if (props.deviceTypeAvailable.length > 0) {
      let filteredDevicesTypes = deviceTypes.filter((deviceType: DeviceType) => {
        if (props.deviceTypeAvailable.includes(deviceType.guid)) return true;
        return false;
      });
      setDeviceTypesFiltered(filteredDevicesTypes);
      if (filteredDevicesTypes.length === 1) {
        props.changeHandler(filteredDevicesTypes[0].guid);
      }
    } else {
      setDeviceTypesFiltered(deviceTypes);
    }
  }, [deviceTypes, props.deviceTypeAvailable]);

  if (!loaded) {
    return null;
  }
  return (
    <FormControl fullWidth>
      <InputLabel id={'device-type-select-label'}>{t('select_device_type')}</InputLabel>
      <Select
        labelId={'device-type-select-label'}
        id={'device-type-select'}
        value={props.deviceTypePreset}
        label={t('select_device_type').toString()}
        onChange={(event) => {
          props.changeHandler(event.target.value as string);
        }}
      >
        {deviceTypesFiltered.map((dt) => {
          return (
            <MenuItem key={dt.guid} value={dt.guid}>
              {dt.attributes.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default DeviceTypePicker;
